import React, { FC } from 'react'
import { useTheme } from '@shared/lib'

const ShieldIcon: FC = () => {
  const theme = useTheme()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="137" height="137" viewBox="0 0 137 137" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09876 52.3129C2.56985 32.5468 3.30539 22.6638 13.2253 12.7439C23.1452 2.82405 33.0282 2.08851 52.7942 0.617428C57.9181 0.236086 63.2036 0.00500488 68.4891 0.00500488C73.7746 0.00500488 79.0601 0.236091 84.184 0.617435C103.95 2.08853 113.833 2.82407 123.753 12.744C133.673 22.6639 134.408 32.5469 135.879 52.3129C136.261 57.4368 136.492 62.7223 136.492 68.0078C136.492 73.2933 136.261 78.5788 135.879 83.7027C134.408 103.469 133.673 113.352 123.753 123.272C113.833 133.191 103.95 133.927 84.1839 135.398C79.0601 135.779 73.7746 136.011 68.4891 136.011C63.2036 136.011 57.9181 135.779 52.7942 135.398C33.0282 133.927 23.1452 133.191 13.2253 123.272C3.30538 113.352 2.56983 103.469 1.09875 83.7026C0.71741 78.5788 0.486328 73.2933 0.486328 68.0078C0.486328 62.7223 0.717414 57.4367 1.09876 52.3129Z"
        fill={theme.colors.state.primaryLinkHover}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.1939 46.0216C55.1736 43.3336 62.554 40.8 68.5003 40.8C74.4465 40.8 81.8269 43.3337 87.8066 46.0217C89.9551 46.9874 90.9596 47.4544 91.6463 47.8828C92.0125 48.2049 92.1472 48.3996 92.2696 48.9553C92.338 49.8276 92.2878 51.0213 92.1581 53.4622C91.4993 65.8594 89.0942 76.9036 82.193 85.7539C80.6105 87.7834 77.9983 90.3257 75.1153 92.3114C72.0435 94.4271 69.6978 95.2 68.5003 95.2C67.3026 95.2 64.9569 94.427 61.8851 92.3113C59.002 90.3257 56.3898 87.7833 54.8073 85.7538C47.9064 76.9035 45.5013 65.8595 44.8423 53.4624C44.7126 51.0214 44.6624 49.8277 44.7308 48.9553C44.8553 48.4401 44.9959 48.2085 45.3541 47.8827C46.0408 47.4543 47.0453 46.9873 49.1939 46.0216Z"
        stroke={theme.colors.icon.primary}
        strokeWidth="7"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ShieldIcon
